export default function TeamLibrary() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Library Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
